<script lang="ts">
    import Text from '$components/common/text/text.svelte';
    export let backgroundImageUrl: string;
    export let bg: string;
    export let title: string;
    export let subTitle: string;
</script>

<div class="product-slide" style={`background-image: url(${bg})`}>
    <div class="slide-container">
        <div class="left">
            <Text class="title" variant="displaySmall" bold>{title}</Text>
            <Text class="description" variant="bodyLarge">
                {@html subTitle}
            </Text>
        </div>
        <div class="right" style={`background-image: url(${backgroundImageUrl})`} />
    </div>
</div>

<style>
    .product-slide {
        /* position: relative; */
        background-size: 140%;
        background-position: top;

        background-repeat: no-repeat;
    }

    @media (min-width: 769px) {
        .product-slide {
            background-size: 140%;
            padding-bottom: 0;
        }
    }

    .slide-container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        max-width: var(--breakpoints-lg);
        margin: 0 auto;
    }

    @media (min-width: 769px) {
        .slide-container {
            flex-direction: row;
            min-height: 747px;
            overflow: hidden;
        }
    }

    @media (min-width: 1400px) {
        .slide-container {
            overflow: inherit;
        }
    }

    .left {
        width: 100%;
        text-align: center;
    }

    @media (min-width: 769px) {
        .left {
            max-width: 445px;
            margin-left: var(--spacing-20);
            text-align: left;
        }
    }

    @media (min-width: 769px) and (max-width: 1199px) {
        .left {
            max-width: 35%;
        }
    }

    @media (max-width: 769px) {
        .left {
            padding-left: var(--spacing-12);
            padding-right: var(--spacing-12);
        }
    }

    .left :global(.title) {
        max-width: 445px;
        margin-bottom: var(--spacing-12);
    }

    .right {
        width: 742px;
        height: 747px;
        background-size: 100%;
        background-position: top;
        background-repeat: no-repeat;
    }

    @media (min-width: 769px) {
        .right {
            position: absolute;
            right: -60px;
            top: 0;
            background-position: right;
        }
    }

    @media (max-width: 769px) {
        .right {
            background-position: top;
            max-width: 100vw;
            max-height: 400px;
        }
    }

    @media (max-width: 1000px) {
        .right {
            top: 60px;
            width: 550px;
            height: 560px;
            background-size: contain;
        }
    }

    .product-slide :global(.description) {
        color: var(--colors-common-light-medium) !important;
    }
</style>
